import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';
import { Button } from '@swagup-com/components';
import { SortBy, FilledSearchField, MultiselectFilter } from '../../../global/Filters';
import { shipmentStatus } from '../../../../apis/constants';

const useTopFiltersStyles = makeStyles(theme => ({
  sortBy: {
    width: 266,
    [theme.breakpoints.down('md')]: {
      width: 222
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  exportBtn: {
    height: 'fit-content',
    fontSize: 14,
    padding: 0,
    '&:hover': {
      color: '#255394'
    }
  },
  exportIcon: {
    width: 14,
    height: 14,
    marginRight: 8
  }
}));

const filterByStatusOptions = [
  { value: 'pending_production', text: shipmentStatus.pendingProduction },
  { value: 'scheduled', text: shipmentStatus.scheduled },
  { value: 'on_its_way', text: shipmentStatus.onItsWay },
  { value: 'delivered', text: shipmentStatus.delivered },
  { value: 'return_to_sender', text: shipmentStatus.returnToSender },
  { value: 'cancelled', text: shipmentStatus.cancelled },
  { value: 'invalid_address', text: shipmentStatus.invalidAddress },
  { value: 'failure', text: shipmentStatus.failure }
];

const sortByPlacedOptions = [
  { value: 'all', text: 'All' },
  { value: 'week_to_date', text: 'Week to date' },
  { value: 'last_30_days', text: '30 days' },
  { value: 'last_90_days', text: '90 days' }
];

const TopFilters = ({
  search,
  statusIn,
  placed,
  onChangeSearch,
  onChangeStatus,
  onChangePlaced,
  onExport,
  exportCSVDisabled
}) => {
  const classes = useTopFiltersStyles();
  return (
    <Grid container item spacing={4}>
      <Grid item md={4} xs={12}>
        <FilledSearchField
          value={search}
          placeholder="Search by product or recipient name"
          onChange={onChangeSearch}
          fullWidth
          height={58}
        />
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <MultiselectFilter
          values={filterByStatusOptions}
          selected={statusIn}
          onApply={onChangeStatus}
          title="Status:"
          defaultText="All Products"
        />
      </Grid>
      <Grid item md={3} sm={6} xs={12}>
        <SortBy
          title="Placed:"
          value={placed}
          onChange={onChangePlaced}
          items={sortByPlacedOptions}
          classes={{ sortBy: classes.sortBy }}
        />
      </Grid>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        item
        md={2}
        sm={12}
        xs={12}
        style={{ padding: '12px 0' }}
      >
        <Button variant="text" className={classes.exportBtn} onClick={onExport} disabled={exportCSVDisabled}>
          <SaveAltOutlinedIcon className={classes.exportIcon} />
          Export Shipments
        </Button>
      </Grid>
    </Grid>
  );
};

export { TopFilters, filterByStatusOptions, sortByPlacedOptions };
